import React, { useContext } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";
import PageContext from "@PageContext";
import WebProfileContext from "@WebProfileContext";

import styles from "./Metamenu.styles";

const ReactLink = loadable(() => import("@micado-digital/react-link/ReactLink"));
const Typography = loadable(() => import("@micado-digital/react-ui/components/Typography"));

const Metamenu = () => {
	const [pageData] = useContext(PageContext);
	const { menuGroups } = pageData;
	const [profileData] = useContext(WebProfileContext);
	const { name } = profileData;
	const css = styles();

	const metamenu = menuGroups?.find(group => group.title === "Metamenü")?.items;

	return (
		<div className={clsx(css.menu, "mco-view-component-footer-meta-menu")}>
			<Typography
				className={clsx(css.copyright, "mco-view-component-footer-meta-menu__copyright")}
				variant="body-small"
			>
				© {new Date().getFullYear()} {name}
			</Typography>
			<ul>
				{metamenu?.map(item => {
					const { id, target, title, link } = item;

					return (
						<li
							className={clsx(css.item, "mco-view-component-footer-meta-menu__item")}
							key={id}
						>
							<ReactLink target={target} to={link}>
								<Typography dangerouslySetInnerHTML={{ __html: title }} variant="body-small" />
							</ReactLink>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Metamenu;
